import React, { useState, useEffect, useRef } from 'react';
import { Typography, Button, Pagination } from 'antd';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import LiveList1 from './components/LiveList1/LiveList1';
import LiveList11 from './components/LiveList1/LiveList11';
import { LiveStream } from './types';

import { getProductList } from '@/api/products';
import LiveList2 from './components/LiveList2/LiveList2';
import FollowList from './components/FollowList/FollowList';
import LiveVideo from './components/LiveVideo/LiveVideo';
import LiveChat from './components/LiveChat/LiveChat';

import icon1 from '@/assets/images/生成美国风格直播封面@2x.png';
import icon2 from '@/assets/images/生成美国风格直播封面@2x (1).png';
import icon3 from '@/assets/images/生成美国风格直播封面@2x (2).png';
import icon4 from '@/assets/images/生成美国风格直播封面@2x (3).png';


import icon5 from '@/assets/images/生成美国风格直播封面 (1)@2x.png';
import icon6 from '@/assets/images/生成美国风格直播封面 (2)@2x.png';
import icon7 from '@/assets/images/生成美国风格直播封面（4）@2x.png';


import icon8 from '@/assets/images/生成美国风格直播封面(4)@2x.png';
import icon9 from '@/assets/images/生成美国风格直播封面 (1)@2x (1).png';
import icon10 from '@/assets/images/生成美国风格直播封面 (3)@2x (1).png';

import icon11 from '@/assets/images/生成美国电商店铺头像 (51)@2x.png';



const { Title } = Typography;


// 模拟过往直播流数据
const liveStreams = [
  {
    id: '1',
    title: 'Boho Vibes Haul: New Arrivals You\'ll Love | Live Shopping',
    author: 'Liv By Viv Amazon Finds',
    avatar: icon11,
    thumbnail: icon1,
    timeLeft: 'ENDS IN 3HRS',
    badges: ['MIDNIGHT DEAL'],
    products: [
      {
        id: '1',
        name: 'Coffee Cup Set',
        price: 25.99,
        image: icon5
      },
      {
        id: '2',
        name: 'Kitchen Mug',
        price: 15.99,
        image: icon6,
      },
      {
        id: '3',
        name: 'Ceramic Bowl',
        price: 18.99,
        image: icon7,
      }
    ]
  },
  {
    id: '2',
    title: 'Boho Vibes Haul: New Arrivals',
    author: 'Liv By Viv Amazon Finds',
    avatar: icon11,
    thumbnail: icon2,
    badges: ['MID SEASON SALE', 'NEW ARRIVALS', 'BEST SELLERS'],
    products: [
      {
        id: '4',
        name: 'Home Decor',
        price: 45.99,
        image: icon8
      },
      {
        id: '5',
        name: 'Throw Pillow',
        price: 32.99,
        image: icon9
      },
      {
        id: '6',
        name: 'Plant Pot',
        price: 28.99,
        image: icon10
      }
    ]
  },
  {
    id: '3',
    title: 'Boho Vibes Haul: New Arrivals',
    author: 'Liv By Viv Amazon Finds',
    avatar: icon11,
    thumbnail: icon3,
    badges: ['HOT TREND', 'BUY ONE GET ONE FREE', 'FREE SHIPPING'],
    products: [
      {
        id: '7',
        name: 'Fashion Jacket',
        price: 89.99,
        image: icon5
      },
      {
        id: '8',
        name: 'Denim Jeans',
        price: 65.99,
        image: icon7
      }
    ]
  },
  {
    id: '4',
    title: 'Boho Vibes Haul: New Arrivals',
    author: 'Liv By Viv Amazon Finds',
    avatar: icon11,
    thumbnail: icon4,
    badges: ['LUXE FINDS', 'LIVE STREAM'],
    products: [
      {
        id: '9',
        name: 'Jewelry Set',
        price: 125.99,
        image: icon8
      },
      {
        id: '10',
        name: 'Earrings',
        price: 45.99,
        image: icon9
      },
      {
        id: '11',
        name: 'Necklace',
        price: 78.99,
        image: icon10
      },
      {
        id: '12',
        name: 'Bracelet',
        price: 35.99,
        image: icon8
      }
    ]
  }
];


const LiveNow: React.FC = () => {
  //国际化
  const { t, i18n } = useTranslation();


  const dispatch = useAppDispatch();

  //获取商品分类进行查询
  const getType = (type: number) => {
    console.log('home组件type', type);
  }

  const [params, setParams] = useState<any>({
    product_category_id: '',
    page_num: 1,
    page_size: 10,
    product_cateogry_brand_id: '',
    total: 0,
    totalPages: 0,
    product_title:''
  });

  // 是否加载中（用于防止重复触发）
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  // 使用 useRef 防止 StrictMode 重复执行
  const hasInitialized = useRef(false);


  


  //商品列表
  const [goodsList, setGoodsList] = useState<any[]>([
    {
      type:1,
      list:liveStreams
    },
    {
      type:1,
      list:liveStreams
    }
  ]);

  //获取商品列表方法
  const getProductListFn = (params: any) => {
    console.log('home组件getProductListFn', params);
    
    // setIsLoading(true);
    // getProductList(params)
    //   .then((res) => {
    //     if (res.code == 200) {
    //       setGoodsList((prev) => [...prev, ...res.data]);
    //       //debugger

    //       // 这里为了处理调10次分页
    //       const nextParams = { 
    //         ...params, 
    //         page_num: params.page_num + 1 ,
    //         total: res.total || 0,
    //         totalPages: res.totalPages || 1,
    //       };
    //       setParams(nextParams);



    //       if(nextParams.page_num <= 10){
        
    //         getProductListFn(nextParams);
    //       }

    //       // 这里为了处理调10次分页


    //     }
    //   })
    //   .finally(() => setIsLoading(false));
  }






  

  // 监听滚动到底部，自动加载下一页  暂时删除
  // useEffect(() => {
  //   const threshold = 120; // 距离底部阈值
  //   const onScroll = () => {
  //     const scrollPosition = window.innerHeight + window.scrollY;
  //     const pageHeight = document.documentElement.scrollHeight;
  //     const nearBottom = scrollPosition >= pageHeight - threshold;
  //     const hasMore = params.totalPages > 0 && params.page_num < params.totalPages;
  //     if (nearBottom && hasMore && !isLoading) {
  //       const nextParams = { ...params, page_num: params.page_num + 1 };
  //       setParams(nextParams);
  //       getProductListFn(nextParams);
  //     }
  //   };
  //   window.addEventListener('scroll', onScroll);
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, [isLoading, params]);


  // useEffect(() => {
  //   console.log('home组件params', params);
  // }, [params]);


  //mounted 和unmounted
  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      getProductListFn(params);
    }
  }, []);


  return (
    <div className={styles['home-container']}>
      {/* <div className="live-guanzhu-box">
        <FollowList />
      </div> */}

      {/* 顶部导航标签 */}
      <div className={styles['top-navigation']}>
        <div className={styles['nav-tabs']}>
          <div className={`${styles['nav-tab']} ${styles['active']}`}>
            {t('liveNow.Discover')}
          </div>
          {/* <div className={styles['nav-tab']}>
            Following
          </div> */}
        </div>
      </div>

      <div className={styles['live-top-box']}>
        <div className={styles['live-top-left']}>
          <LiveVideo />
        </div>
        <div className={styles['live-top-right']}>
          <LiveChat />
        </div>
      </div>

      <div className={styles['live-bottom-box']}>
        {/* 显示直播列表2 - 大图横幅轮播 */}
        {/* <LiveList2 getType={getType} goodsList={goodsList} /> */}
        
        {/* 显示直播列表1 - 过往直播卡片 */}
        {
          goodsList?.map((item, index) => {
            if (item.type == 1) {
              return (
                <div key={index}>
                  <LiveList1 liveStreams={item.list} />
                </div>
              )
            }
            return null;
          })
        }
            

      </div>
      


    </div>
  );
};

export default LiveNow; 